export default __webpack_public_path__ + "static/media/icon_rawmjml.0d7620aa.svg";